import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "m8 6 4-4 4 4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 2v10.3a4 4 0 0 1-1.172 2.872L4 22", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m20 22-5-5", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Merge";
const Merge = memo(themed(Icon));
export {
  Merge
};
//# sourceMappingURL=merge.js.map
